const createUnderline = () => ({
  parseDOM: [{ tag: "u" }],
  toDOM: () => ["u", 0],
});

export default createUnderline;
